import { useMemo } from 'react';
import { useLocation } from '@tanstack/react-router';
import LiliLogoUrl from '@Assets/logos/lili-logo-blue.svg';
import { useBoundStore } from '@Store/index.ts';
import { useNavigationManager } from '@Router/useNavigationManager';
import { Icon, Icons } from '@Components/icon/Icon.tsx';
import { routesModel } from '@Router/router.consts.ts';
import { RoutesMap } from '@Router/router.types.ts';

interface MobileNavigationHeaderProps {
  showBackButton?: boolean;
}
export const MobileNavigationHeader = ({ showBackButton = true }: MobileNavigationHeaderProps) => {
  const { pathname } = useLocation();
  const { currentPageIndex, navigationStack } = useBoundStore((state) => state.onboardingSlice);
  const { navigateToPreviousPage, navigateToSpecificPage, isAllowedPrevPage } =
    useNavigationManager();

  const progressValue = useMemo(() => {
    return (currentPageIndex / (navigationStack.length - 1)) * 100;
  }, [currentPageIndex, navigationStack]);
  const callbackMap: Record<string, () => void> = {
    [routesModel[RoutesMap.ADD_OWNER].path]: () => navigateToSpecificPage(RoutesMap.OWNER_CENTER),
  };
  return (
    <div
      id='mobile-navigation-header'
      data-testid='mobile-navigation-header'
      className='px-[16px] flex w-full shrink-0 max-h-[60px] h-[60px] bg-surface-primary-bw-00 sm:hidden relative'>
      <div className='flex items-center justify-between w-full h-full'>
        {isAllowedPrevPage && showBackButton && (
          <button
            id='back-mobile'
            data-testid='back-mobile'
            type='button'
            onClick={() => {
              if (callbackMap[pathname]) {
                callbackMap[pathname]();
              } else {
                navigateToPreviousPage();
              }
            }}>
            <Icon icon={Icons.MobileBack} className='text-surface-primary-bw-07' />
          </button>
        )}
        <img
          className='absolute left-1/2 -translate-x-1/2 w-[40px]'
          src={LiliLogoUrl}
          alt='Lili Logo'
        />
      </div>
      <div className='flex w-full h-[3px] bg-surface-primary-bw-03 absolute left-0 bottom-0'>
        <span
          style={{ width: `${progressValue}%` }}
          className=' bg-surface-brand-action-03 h-full'
        />
      </div>
    </div>
  );
};
